import { safeLocalStorage } from 'utils/safeStorage';

interface StorageItem {
  value: string;
  expiry: number;
}

export const setWithExpiry = (key: string, value: string, ttl: number): void => {
  const item: StorageItem = {
    value,
    expiry: Date.now() + ttl,
  };
  safeLocalStorage.setItem(key, JSON.stringify(item));
};

export const getWithExpiry = (key: string): string | null => {
  const itemStr = safeLocalStorage.getItem(key);
  if (!itemStr) return null;

  const item: StorageItem = JSON.parse(itemStr);
  if (Date.now() > item.expiry) {
    safeLocalStorage.removeItem(key);
    return null;
  }
  return item.value;
};
